import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { AzureMonitoringService } from 'app/core/services/AzureMonitoringService';
import { CustomersRestService } from 'app/core/services/rest/customers.rest.service';
import { AbstractEffects } from 'app/core/store/AbstractEffects';
import { Observable, of } from 'rxjs';
import * as actions from './sap-invoice.actions';
import { GetValutaForCustomersAction } from './sap-invoice.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';

@Injectable({ providedIn: 'root' })
export class SapInvoiceEffects extends AbstractEffects {
  getValutaForCustomer$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<GetValutaForCustomersAction>(actions.GET_VALUTA_FOR_CUSTOMERS),

      switchMap(({ payload }) => {
        return this.customerRestService.getValutaForCustomer(payload).pipe(
          map((data: { valutas: string[] }) => {
            return new actions.GetValutaForCustomersSuccessAction({ valutas: data.valutas });
          }),
          catchError(err => {
            return this.handleFail(err, 'Get customer info', [of(new actions.GetValutaForCustomersFailAction(err))]);
          })
        );
      })
    )
  );

  constructor(azureMonitoringService: AzureMonitoringService, translateService: TranslateService, private actions$: Actions, private customerRestService: CustomersRestService, notificationService: NotificationService) {
    super(translateService, azureMonitoringService, notificationService);
  }
}
